import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'Modal';
import { Text } from 'Text';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    The locked reason on a phone. Desktop shows it as a tooltip on the row.
*/

type Props = {
    reasonMessage: string;
    onClose: () => void;
};

export const LessonLockedModal: FC<Props> = ({ reasonMessage, onClose }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    return (
        <Modal title={t('lesson_locked_title')} onClose={onClose} size="sm">
            <div className="px-7.5 pb-10 pt-6">
                <Text as="p" className="text-center text-md text-black">
                    {reasonMessage}
                </Text>
            </div>
        </Modal>
    );
};
